import React from 'react';
import classNames from 'classnames';
import { ReactComponent as Arrow } from 'assets/icons/calculator/slider-arrow-back.svg';

import style from '../../styles/pagination.module.scss';

const NextPrevButton = ({ side }) => {
  const arrowClasses = classNames({
    [style.pagination__arrow]: true,
    [style[`pagination__arrow--${side}`]]: true,
  });

  const btnText = side === 'prev' ? 'Предыдущая' : 'Следующая';

  return (
    <button
      type="button"
      className={classNames({
        [style.pagination__button]: true,
      })}
    >
      {side === 'prev' ? <Arrow className={arrowClasses} /> : null}
      <span className={style.pagination__text}>{btnText}</span>
      {side === 'next' ? <Arrow className={arrowClasses} /> : null}
    </button>
  );
};

export default NextPrevButton;
